import type { ReactNode } from "react";

import styles from "./Card.module.css";

interface CardProps {
  title?: string;
  toolbar?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Card({ title, toolbar, children, className }: CardProps) {
  return (
    <section className={[styles.card, className].filter(Boolean).join(" ")}>
      {(title || toolbar) && (
        <header className={styles.header}>
          {title && <h2 className={styles.title}>{title}</h2>}
          {toolbar && <div className={styles.toolbar}>{toolbar}</div>}
        </header>
      )}
      <div className={styles.body}>{children}</div>
    </section>
  );
}
